import { signOut } from 'next-auth/react';
import { useState } from 'react';

import { nextAuthPageOptions } from 'lib/server/auth/config.ts';

export function useSignOut() {
  const [loadingLogout, setLoadingLogout] = useState(false);

  async function handleLogout() {
    setLoadingLogout(true);
    await signOut({ redirectTo: nextAuthPageOptions.signIn }).finally(() =>
      setLoadingLogout(false),
    );
  }

  return { handleLogout, loadingLogout };
}
